import React, { useState } from 'react'
import './notificationBanner.scss'
import NotificationIcon from './NotificationIcon'
import CloseIcon from './CloseIcon'

function NotificationBanner() {

  const [isBannerOpen, setIsBannerOpen] = useState(true)

  return (
      isBannerOpen ?
      <div className='notification-banner'>
        <button className='notification-banner__close-btn' onClick={() => setIsBannerOpen(false)}>
          <CloseIcon />
        </button>
        <NotificationIcon />
        <div>
          <p className='notification-banner__main-msg'>This site will be discontinued soon.</p>
          <p>
            <strong>trolly.ai</strong> is now merged with <a href='https://netus.ai/seo-article-generator' target='_blank' rel='noreferrer'> netus.ai</a>. All users are requested to <a href='https://app.netus.ai/signup' target='_blank' rel='noreferrer'>create an account</a> on <strong>netus.ai</strong>, where you can avail much better results and more features. 
          </p>
        </div>
      </div> : null
  )
}

export default NotificationBanner